'use client';

import {useRef} from 'react';

import Slider from 'react-slick';

import MuiBox from '@new-components/atoms/MuiBox';
import MuiIconButton from '@new-components/atoms/MuiIconButton';

import TestimonialsImageSection from './TestimonialsImageSection';
import TestimonialsContentSection from './TestimonialsContentSection';

import {MediaQuery} from '@constants/theme';

import PrevSlideIcon from '@components/SVGIcon/Icons/PrevSlideIcon';
import NextSlideIcon from '@components/SVGIcon/Icons/NextSlideIcon';

import {carouselSettings as settings} from '@new-components/molecules/TestimonialsOnExperiences/constants';

import {UserExperiences} from '@new-components/molecules/TestimonialsOnExperiences/types';

const TestimonialsOnExperiencesSlider = ({
  userExperinces,
}: {
  userExperinces: UserExperiences[];
}): JSX.Element => {
  const sliderRef = useRef<Slider | null>(null);

  const handlePrev = (): void => sliderRef?.current?.slickPrev();
  const handleNext = (): void => sliderRef?.current?.slickNext();
  return (
    <Slider ref={sliderRef} {...settings}>
      {userExperinces?.map((item, index) => (
        <MuiBox
          key={index}
          sx={{
            paddingX: {xs: 0.5, sm: 2, md: 0},
            color: 'inherit',
            width: '100%',
            textDecoration: 'none',
            overflow: 'hidden',
            marginTop: 3,
            display: 'flex',
            flexDirection: 'column',
            [MediaQuery.desktop]: {
              marginTop: 7,
              marginRight: 0,
              transition: 'width .5s ease-in-out',
              width: '100%',
            },
          }}>
          <MuiBox
            sx={{
              display: 'flex',
              [MediaQuery.mobile]: {
                flexDirection: 'column',
              },
            }}>
            <TestimonialsImageSection userExperiences={item} key={index} />
            <TestimonialsContentSection
              handlePrev={handlePrev}
              handleNext={handleNext}
              userExperinces={item}
              key={index}
            />
          </MuiBox>
          {/* Navigation buttons to be visibe via mobile view */}
          <MuiBox
            sx={{
              display: 'flex',
              marginTop: 3,
              [MediaQuery.desktop]: {
                display: 'none',
              },
            }}>
            <MuiIconButton
              onClick={handlePrev}
              data-testid='fcc-prev-button'
              sx={{
                'width': '40px',
                'height': '40px',
                '&.Mui-disabled': {
                  opacity: 0.5,
                },
                'cursor': 'pointer',
              }}>
              <PrevSlideIcon />
            </MuiIconButton>
            <MuiIconButton
              onClick={handleNext}
              data-testid='fcc-next-button'
              sx={{
                'width': '40px',
                'height': '40px',
                '&.Mui-disabled': {
                  opacity: 0.5,
                },
                'cursor': 'pointer',
              }}>
              <NextSlideIcon />
            </MuiIconButton>
          </MuiBox>
        </MuiBox>
      ))}
    </Slider>
  );
};

export default TestimonialsOnExperiencesSlider;
